module.exports = __webpack_public_path__ + "static/media/arlac.39c9f9cc.png";